import React from 'react';
import { UiBsContentContainer } from 'styles';
import { SessionManagementTable, BsHeaderTitle } from 'components';



/**
 * 課程管理列表
 */

export const SessionManagementPage = () => {
  return (
    <>
      <BsHeaderTitle title={'課程總覽'} />
      <UiBsContentContainer>
        <SessionManagementTable />
      </UiBsContentContainer>
    </>
  );
};

SessionManagementPage.propTypes = {

};


